// extracted by mini-css-extract-plugin
module.exports = {"addFeed":"styles_addFeed__ljWIq"};